module.exports = __webpack_public_path__ + "assets/excel.25efb1e4.svg";